import Search from './search';
import './styles/index.scss';
export default Search;
